module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/notosanskr/notokr-regular.woff
// module id = XTnn
// module chunks = 0